export const errorMesssage = (errCode: string): string => {
    return SYS_ERROR_MESSAGES[errCode] || SYS_ERROR_MESSAGES[ERROR_CODE.UNKNOW];
};

export const ERROR_CODE = {
    UNKNOW: '000001',
    DATA_PROCESS: '000002',
    REQUEST_INVALID: '000003',
    ENTITY_EXISTED: '000004',
    UNAUTHORIZED: '000005',
    FORBIDDEN: '000006',
    NOT_FOUND: '000007',
    MISSING_MIDDLEWARE: '000008',
    TOKEN_EXPIRED: '000009',
    ACCOUNT_NOT_HAVE_EMAIL: '000011',
    RESET_PASSWORD_TOKEN_EXPIRED: '000012',
    EMAIL_NOT_MATCH: '000013'
};

export const SYS_ERROR_MESSAGES = {
    [ERROR_CODE.UNKNOW]: 'Đã có lỗi xảy ra. Vui lòng liên hệ Weset',
    [ERROR_CODE.DATA_PROCESS]: 'Xử lý dữ liệu xảy ra lỗi. Vui lòng liên hệ Weset',
    [ERROR_CODE.REQUEST_INVALID]: 'Yêu cầu không hợp lệ',
    [ERROR_CODE.ENTITY_EXISTED]: 'Dữ liệu đã tồn tại',
    [ERROR_CODE.UNAUTHORIZED]: 'Tên đăng nhập hoặc mật khẩu không đúng',
    [ERROR_CODE.FORBIDDEN]: 'Không có quyền truy cập',
    [ERROR_CODE.NOT_FOUND]: 'Không tìm thấy dữ liệu',
    [ERROR_CODE.TOKEN_EXPIRED]: 'Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại',
    [ERROR_CODE.ACCOUNT_NOT_HAVE_EMAIL]: 'Tài khoản chưa có email. Vui lòng liên hệ học vụ',
    [ERROR_CODE.RESET_PASSWORD_TOKEN_EXPIRED]: 'Đường dẫn cập nhật mật khẩu đã hết hạn. Vui lòng thực hiện lại thao tác',
    [ERROR_CODE.EMAIL_NOT_MATCH]: 'Em không đúng. Vui lòng thực hiện lại thao tác'
};

export const ERROR_UI_MESSAGES = {
    CONFIRM_PASSWORD_NOT_MATCH: 'Mật khẩu lặp lại không trùng khớp',
    RESET_LINK_INVALID: 'Đường dẫn cập nhật mật khẩu không hợp lệ'
};

export const SUCCESS_MESSAGE = {
    CHANGE_PWD: 'Đổi mật khẩu thành công!',
    FORGOT_PWD: 'Hệ thống đã gửi đường dẫn cập nhật mật khẩu vào email',
    SYNC_DATA: 'Đồng bộ thành công'
};
